import { Link, useLocation, useNavigate } from "react-router-dom";
import { Braces, LayoutDashboard, LogOut, Plus, Sparkles, User } from "lucide-react";
import { useAuth } from "@/lib/auth";

const NAV = [
  { to: "/dashboard", label: "Projects", icon: LayoutDashboard, testId: "nav-dashboard" },
  { to: "/projects/new", label: "New Run", icon: Plus, testId: "nav-new" },
];

export default function Sidebar() {
  const loc = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();

  const doLogout = () => { logout(); nav("/login"); };

  return (
    <aside className="hidden lg:flex flex-col w-[240px] border-r border-border shrink-0 h-screen sticky top-0">
      <Link to="/" className="flex items-center gap-2 px-6 h-16 border-b border-border" data-testid="sidebar-logo">
        <div className="w-8 h-8 rounded-sm bg-accent text-accent-foreground grid place-items-center">
          <Braces className="w-4 h-4" strokeWidth={2} />
        </div>
        <div>
          <div className="font-display font-bold text-lg leading-none">MLForge</div>
          <div className="label-mono mt-1">AI ML ENGINEER</div>
        </div>
      </Link>
      <nav className="p-3 flex flex-col gap-1">
        {NAV.map(({ to, label, icon: Icon, testId }) => {
          const active = loc.pathname === to || (to !== "/dashboard" && loc.pathname.startsWith(to));
          return (
            <Link
              key={to}
              to={to}
              data-testid={testId}
              className={`flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors ${
                active
                  ? "bg-secondary text-foreground"
                  : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              }`}
            >
              <Icon className="w-4 h-4" strokeWidth={1.5} />
              {label}
            </Link>
          );
        })}
      </nav>
      <div className="mt-auto p-3 border-t border-border space-y-2">
        <div className="rounded-sm border border-border p-3 bg-secondary/40">
          <div className="flex items-center gap-2 text-xs">
            <Sparkles className="w-3.5 h-3.5 text-accent" />
            <span className="font-medium">Multi-agent</span>
          </div>
          <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed">
            A LangGraph supervisor routes your questions to <span className="font-mono">Dataset Analyst</span>, <span className="font-mono">ML Engineer</span>, <span className="font-mono">Reviewer</span> or <span className="font-mono">Report Writer</span>.
          </p>
        </div>
        {user && (
          <div className="flex items-center gap-2 px-3 py-2 rounded-sm bg-secondary/30 border border-border" data-testid="sidebar-user">
            <div className="w-6 h-6 rounded-sm bg-accent/15 text-accent grid place-items-center shrink-0">
              <User className="w-3 h-3" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-mono truncate">{user.username}</div>
              <div className="label-mono">SIGNED IN</div>
            </div>
            <button
              onClick={doLogout}
              data-testid="sidebar-logout"
              title="Sign out"
              className="text-muted-foreground hover:text-destructive transition-colors"
            >
              <LogOut className="w-3.5 h-3.5" />
            </button>
          </div>
        )}
      </div>
    </aside>
  );
}
